import React, {Component} from 'react';
import {connect} from 'react-redux';
import _ from 'lodash';
import {Modal, Button, Input, Grid, Dimmer, Loader} from 'semantic-ui-react';
import {getSystemParameterValue} from '../../../../common/util/parametersUtils';
import {Actions} from '../../../../common/actions';
import './reprinterLabels.scss';

class ReprinterLabelsModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      'modalWasOpen': false,
      'printCode': '',
      'initialCode': '',
      'finalCode': '',
      'showError': true,
      'errorMessage': '',
    };
    this.onPrintCodeChange = this.onPrintCodeChange.bind(this);
    this.onInitialCodeChange = this.onInitialCodeChange.bind(this);
    this.onFinalCodeChange = this.onFinalCodeChange.bind(this);
    this.onCloseModalClick = this.onCloseModalClick.bind(this);
    this.onAceptModalClick = this.onAceptModalClick.bind(this);
  }

  componentDidUpdate(prevProps) {
    const {loadingLabels, labels} = this.props;

    if (prevProps.loadingLabels && !loadingLabels && labels.length === 0) {
      this.props.addMessageBoxWarning(
        'No se encontraron etiquetas con los datos proporcionados'
      );
    }
  }

  renderError() {
    const {showError, errorMessage} = this.state;
    if (!showError) {
      return null;
    }
    return <p className='error'>{errorMessage}</p>;
  }

  openModal() {
    this.setState({
      'modalWasOpen': true,
      'printCode': '',
      'initialCode': '',
      'finalCode': '',
      'showError': true,
    });
  }

  onPrintCodeChange(event) {
    const value = event.target.value ? parseInt(event.target.value, 10) : '';
    const newState = {'printCode': value, 'showError': false, 'errorMessage': ''};

    if (!value || value < 1) {
      newState.showError = true;
      newState.errorMessage =
        'El código de impresión debe ser un número entero mayor que cero.';
    }
    this.setState(newState);
  }

  onInitialCodeChange(event) {
    const {finalCode} = this.state;
    const value = event.target.value ? parseInt(event.target.value, 10) : '';
    const newState = {'initialCode': value, 'showError': false, 'errorMessage': ''};

    if (value === '') {
      newState.showError = true;
    } else if (value < 1) {
      newState.showError = true;
      newState.errorMessage =
        'El secuencial inicial debe ser igual o mayor a 1';
    } else if (finalCode && value > finalCode) {
      newState.showError = true;
      newState.errorMessage =
        'El secuencial final debe ser mayor o igual al inicial';
    }
    this.setState(newState);
  }

  onFinalCodeChange(event) {
    const {initialCode} = this.state;
    const value = event.target.value ? parseInt(event.target.value, 10) : '';
    const newState = {'finalCode': value, 'showError': false, 'errorMessage': ''};

    if (initialCode === '') {
      newState.showError = true;
    }
    this.setState(newState);
  }

  onCloseModalClick() {
    this.setState({'modalWasOpen': false});
  }

  onAceptModalClick() {
    this.reprintLabels();
    this.onCloseModalClick();
  }

  reprintLabels() {
    const {systemParameters} = this.props;
    const {printCode, initialCode, finalCode} = this.state;
    const queryStrings = {'start': initialCode, 'end': finalCode};
    const labelsBlockSize =
      getSystemParameterValue(systemParameters, 'PICKING_LABELS_TO_CUT') || 10;

    this.props.reprintPickingLabels(printCode, labelsBlockSize, queryStrings);
  }

  findIndex(sequence) {
    const {labels, orderCode} = this.props;

    const labelsByOrderCode = labels[orderCode] || [];
    return _.findIndex(labelsByOrderCode, function(o) {
      return o.sequence === sequence;
    });
  }

  render() {
    const {trigger, loadingLabels} = this.props;
    const {modalWasOpen, printCode, initialCode, finalCode, showError} =
      this.state;

    return (
      <Modal
        size='tiny'
        onOpen={() => this.openModal()}
        open={modalWasOpen}
        className='reprinter-picking-labels'
        trigger={trigger}
      >
        <Modal.Header>Reimprimir Etiquetas de Picking</Modal.Header>

        <Modal.Content>
          <Dimmer active={loadingLabels}>
            <Loader />
          </Dimmer>
          <Modal.Description>
            <Grid>
              <Grid.Row>
                <Grid.Column width={16}>
                  Ingrese el código de Impresión
                </Grid.Column>
              </Grid.Row>
              <Grid.Row>
                <Grid.Column width={16}>
                  <Input
                    fluid
                    required
                    placeholder='Código de Impresión'
                    type='number'
                    className='finalCode'
                    value={printCode}
                    min='1'
                    step='1'
                    onChange={this.onPrintCodeChange}
                  />
                </Grid.Column>
              </Grid.Row>
              <Grid.Row>
                <Grid.Column width={16}>
                  Ingrese el intervalo de las etiquetas que desea reimprimir
                </Grid.Column>
              </Grid.Row>
              <Grid.Row>
                <Grid.Column width={8}>
                  <Input
                    fluid
                    placeholder='Secuencia Inicial'
                    type='number'
                    required
                    value={initialCode}
                    min='1'
                    step='1'
                    onChange={this.onInitialCodeChange}
                  />
                </Grid.Column>
                <Grid.Column width={8}>
                  <Input
                    fluid
                    placeholder='Secuencia Final'
                    type='number'
                    className='finalCode'
                    value={finalCode}
                    min={initialCode}
                    step='1'
                    onChange={this.onFinalCodeChange}
                  />
                </Grid.Column>
              </Grid.Row>
            </Grid>
            {this.renderError()}
          </Modal.Description>
        </Modal.Content>

        <Modal.Actions>
          <Button onClick={this.onCloseModalClick}>Cancelar</Button>
          <Button
            positive
            disabled={showError}
            onClick={this.onAceptModalClick}
          >
            Aceptar
          </Button>
        </Modal.Actions>
      </Modal>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    'systemParameters': state.parameters.list,
    'loadingLabels': state.pickingDashboard.loadingLabelsToReprint,
    'labels': state.pickingDashboard.labelsToBeReprinted,
  };
};

const {addMessageBoxError, addMessageBoxWarning, reprintPickingLabels} =
  Actions;

export default connect(mapStateToProps, {
  addMessageBoxError,
  addMessageBoxWarning,
  reprintPickingLabels,
})(ReprinterLabelsModal);
